export const MANAGER_SETTINGS_STORAGE_KEY =
  'safeviewComplaintManagerSettingsV1';

export const DEFAULT_CRITICAL_KEYWORDS =
  'attorney, lawyer, sue, legal, news, reporter, channel, media';

const LEGACY_DEFAULT_CRITICAL_KEYWORDS =
  'attorney, lawyer, sue, legal, news, reporter, channel, media, police, weapon';

export const normalizeCriticalKeywordsText = (keywords: string) => {
  const normalized = keywords.trim();

  return normalized.toLowerCase() === LEGACY_DEFAULT_CRITICAL_KEYWORDS
    ? DEFAULT_CRITICAL_KEYWORDS
    : normalized;
};

const parseCriticalKeywords = (keywords: string) =>
  normalizeCriticalKeywordsText(keywords || DEFAULT_CRITICAL_KEYWORDS)
    .split(',')
    .map((keyword) => keyword.trim().toLowerCase())
    .filter(Boolean);

export const getConfiguredCriticalKeywords = () => {
  if (typeof globalThis === 'undefined' || !globalThis.localStorage) {
    return parseCriticalKeywords(DEFAULT_CRITICAL_KEYWORDS);
  }

  try {
    const settings = JSON.parse(
      globalThis.localStorage.getItem(MANAGER_SETTINGS_STORAGE_KEY) || '{}'
    );
    const keywords = normalizeCriticalKeywordsText(
      String(
        settings?.automation?.criticalKeywords || DEFAULT_CRITICAL_KEYWORDS
      )
    );

    return parseCriticalKeywords(keywords || DEFAULT_CRITICAL_KEYWORDS);
  } catch {
    return parseCriticalKeywords(DEFAULT_CRITICAL_KEYWORDS);
  }
};
